import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'GlobalMinimalFooter',
})(({ brandColors, spacing, breakpoints, type, typography }, props) => ({
  container: {
    padding: `${spacing(3)} ${spacing(4)} ${spacing(5)} ${spacing(4)}`,
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    flexFlow: 'column',
    minHeight: typography.pxToRem(182),
    [breakpoints.up('sm')]: {
      minHeight: typography.pxToRem(158),
    },
    [breakpoints.up('md')]: {
      flexFlow: 'row',
      minHeight: typography.pxToRem(124),
    },
    [breakpoints.up('lg')]: {
      minHeight: typography.pxToRem(204),
    },
  },
  copyright: {
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.mediumBlue
    ),
    ...type['14_regular'],
    [breakpoints.up('sm')]: {
      width: 'auto',
      marginTop: 0,
    },
  },
  legalLinks: {
    color: darkOrLightStyle(props)(
      brandColors.tintsChargeBlue60,
      brandColors.mediumBlue
    ),
    ...type['14_medium'],
    width: '100%',
    marginTop: spacing(-1),
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    [breakpoints.up('md')]: {
      width: 'auto',
      marginTop: 0,
    },
  },
  legalLink: {
    gap: `${typography.pxToRem(8)}  ${spacing(-1)}`,
    marginTop: spacing(-1),
    marginLeft: spacing(-1),
    marginRight: spacing(-1),
    '&:hover': {
      color: darkOrLightStyle(props)(
        brandColors.white,
        brandColors.primaryMain
      ),
    },
    '& a': {
      ...type['14_medium'],
      whiteSpace: 'nowrap',
    },
    [breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  legalLinkPrivacy: {
    marginRight: `${typography.pxToRem(0)} !important`,
  },
  legalLinkSlash: {
    marginTop: spacing(-1),
    [breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  privacyOptions: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(-1),
    marginLeft: typography.pxToRem(4),
    marginRight: typography.pxToRem(4),
    [breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
}));

export default useStyles;
